import React, { Fragment, useEffect } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import avatar1 from "../../assets/images/users/avatar-1.jpg"
import profileImg from "../../assets/images/profile-img.png"
import { useDispatch, useSelector } from "react-redux"
import { getTenant } from "store/actions";

const WelcomeComp = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTenant());
  }, [])

  const { profile, tenant } = useSelector(state => ({
    profile: state.profiles.profile,
    tenant: state.tenants.tenant

  }));

  let _profile = profile?.profile

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary bg-soft">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Welcome Back !</h5>
                <p>{tenant?.name}</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="5">
              <div className="avatar-md profile-user-wid mb-2">
                <img
                  src={_profile?.avatar || avatar1}
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <h5 className="font-size-15">{_profile ? `${_profile.first_name} ${_profile.last_name}` : "Admin"}</h5>
            </Col>

            <Col sm="7">
              <div className="pt-4">
                <Row>
                  <Col xs="12">
                    {
                      profile?.phone &&
                      <Fragment>
                        <h5 className="font-size-14 mb-0 ">Phone: </h5>
                        <p className="text-muted mb-2">{profile?.phone}</p>
                      </Fragment>
                    }
                    {
                      profile?.email &&
                      <Fragment>
                        <h5 className="font-size-14 mb-0 ">Email: </h5>
                        <p className="text-muted mb-0">{profile?.email}</p>
                      </Fragment>
                    }
                  </Col>
                </Row>
                <div className="mt-4">
                  <Link
                    to="/profile"
                    className="btn btn-primary  btn-sm"
                  >
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp
